import React from 'react';
import Navbar from '../components/Home/Navbar';
import Hero from '../components/Home/Hero';
import QuickInfo from '../components/Home/QuickInfo';
import Specialties from '../components/Home/Specialties';
import Footer from '../components/Home/Footer';
import Gallery from '../components/Home/Gallery';

const TempleHome = () => {
  return (
    <div className="min-h-screen bg-orange-50 text-stone-900 font-sans">
      <Navbar />
      <Hero />
      <QuickInfo />
      <Specialties />
      <Gallery/>
      <Footer />
    </div>
  );
};

export default TempleHome;